/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flightbridge__logo[_ngcontent-%COMP%]{padding-bottom:5px}.flightbridge__content[_ngcontent-%COMP%]{font-size:.789em;color:#626767;line-height:1.36;white-space:pre-wrap}.flightbridge__link[_ngcontent-%COMP%]{font-weight:700}.flightbridge__button-bar-container[_ngcontent-%COMP%]{display:flex;justify-content:space-evenly}.flightbridge__button-inner-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-top:10px;align-items:center}.flightbridge__button-header[_ngcontent-%COMP%]{font-size:20px;font-weight:700}"];
export { styles as styles };
